var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import Divider from '../../components/Divider';
import EmptyListState from '../../components/EmptyListState';
import CartItemList from './partials/CartItemList';
import CtaButton from '../../components/CtaButton';
import PageHeaderBlock from '../../components/PageHeaderBlock';
import ProviderBlock from '../../components/ProviderBlock';
import CouponForm from './partials/CouponForm';
import CurrencyFormatter from '../../core/utils/currency-formatter';
import ContentLoader from '../../components/ContentLoader';
import { localizeUrl } from '../../core/helpers/url-helper';
import { fetchCartItems, fetchShippingFee } from './store/actions';
import { getCartTotal } from '../../core/helpers/cart-helper';
import { validateCoupon } from '../Coupon/store/actions';
import { getEstimatedDateFrom, getEstimatedDateTo } from '../../core/helpers/delivery-helper';
var mapStateToProps = function (state) { return ({
    auth: state.auth,
    coupon: state.coupon,
    collection: state.cart.cartItems.collection,
    shippingFee: state.cart.shippingFee,
}); };
var mapDispatchToProps = {
    fetchShippingFee: fetchShippingFee,
    fetchCartItems: fetchCartItems,
    validateCoupon: validateCoupon,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Cart.prototype.componentDidMount = function () {
        this.initializeComponent();
    };
    Cart.prototype.render = function () {
        var _a, _b;
        if ('loaded' !== this.props.collection.status || !Array.isArray(this.props.collection.items)) {
            return React.createElement(ContentLoader, null);
        }
        if (!this.props.collection.items.length) {
            return (React.createElement("div", { className: "h-padding-top--30" },
                React.createElement(EmptyListState, { image: "drafts-empty.svg", title: "cart.empty.title", message: "cart.empty.message", button: "cart.empty.button.text", buttonLink: localizeUrl('/products') }),
                React.createElement("div", { className: "h-padding-y--30" })));
        }
        return (React.createElement("div", { className: "p-cart" },
            React.createElement("div", { className: "p-cart__header" },
                React.createElement(PageHeaderBlock, { title: "cart.title" })),
            React.createElement("div", { className: "p-cart__content" },
                React.createElement("div", { className: "p-cart__items" },
                    React.createElement(CartItemList, { items: this.props.collection.items }),
                    React.createElement("div", { className: "p-cart__items__button" },
                        React.createElement(Divider, null),
                        React.createElement("div", { className: "h-padding-top--15" },
                            React.createElement(CtaButton, { link: localizeUrl('/products'), icon: "add", label: "button.add_more_product", modifier: ['pink-100', 'icon-right', 'wide', 'xs-full'] })))),
                React.createElement("div", { className: "p-cart__summary" },
                    React.createElement("div", { className: "c-cart-summary" },
                        React.createElement("div", { className: "c-cart-summary__line" },
                            React.createElement("div", { className: "c-cart-summary__line__header" },
                                React.createElement("h2", null,
                                    React.createElement("i", { className: "icon-shipping" }),
                                    this.props.t('cart.delivery.title')),
                                React.createElement("span", null, this.props.shippingFee.shippingFee ? CurrencyFormatter.format(this.props.shippingFee.shippingFee) : this.props.t('cart.delivery.free'))),
                            ((_b = (_a = this.props.auth.item.item) === null || _a === void 0 ? void 0 : _a.default_shipping_address) === null || _b === void 0 ? void 0 : _b.country_id) && (React.createElement("div", { className: "c-cart-summary__line__content" }, this.props.t('cart.delivery.estimation', {
                                fromDate: getEstimatedDateFrom(this.props.auth.item.item.default_shipping_address.country_id),
                                toDate: getEstimatedDateTo(this.props.auth.item.item.default_shipping_address.country_id),
                            })))),
                        React.createElement("div", { className: "c-cart-summary__line" },
                            React.createElement(CouponForm, null)),
                        React.createElement("div", { className: "c-cart-summary__line c-cart-summary__line--total" },
                            React.createElement("div", { className: "c-cart-summary__line__header" },
                                React.createElement("h2", null, this.props.t('cart.total')),
                                React.createElement("span", null, CurrencyFormatter.format(getCartTotal(this.props.collection.items, this.props.coupon.item, this.props.shippingFee.shippingFee))))),
                        React.createElement("div", { className: "c-cart-summary__checkout" },
                            React.createElement(CtaButton, { link: 'loaded' !== this.props.auth.item.status ? localizeUrl('/auth?checkout=1') : localizeUrl('/cart/checkout'), icon: "arrow-right", label: "button.checkout", modifier: ['yellow', 'icon-right', 'lg', 'shadow', 'full'] }))),
                    React.createElement("div", { className: "p-cart__summary__providers" },
                        React.createElement("div", { className: "h-margin-top--30" },
                            React.createElement(ProviderBlock, { link: this.props.t('navigation.links.pricing_and_shipping.url'), icon: "secure-payment", title: "providers.payment.title", image: "providers/payment.png" })),
                        React.createElement("div", { className: "h-margin-top--15 h-margin-top--md-30" },
                            React.createElement(ProviderBlock, { link: this.props.t('navigation.links.pricing_and_shipping.url'), icon: "delivery", title: "providers.shipping.title", image: "providers/shipping.png", modifier: ['title-green'] }))))),
            React.createElement("div", { className: "h-padding-y--30" })));
    };
    Cart.prototype.initializeComponent = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var coupon;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.props.fetchCartItems();
                        this.props.fetchShippingFee();
                        if (!(localStorage && localStorage.getItem('coupon'))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.validateCoupon((_a = localStorage.getItem('coupon')) !== null && _a !== void 0 ? _a : '')];
                    case 1:
                        coupon = _b.sent();
                        if (!coupon) {
                            localStorage.removeItem('coupon');
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return Cart;
}(React.Component));
export default connector(withRouter(withTranslation()(Cart)));
